export function getWindDirection(deg) {
    const directions = ['С', 'СВ', 'В', 'ЮВ', 'Ю', 'ЮЗ', 'З', 'СЗ'];
    return directions[Math.round(deg / 45) % 8];
}

export async function updateWeather() {
    try {
        const apiKey = '9dbe75ce0b108578b50683f2d9474ea9';
        const lat = 52.9685;
        const lon = 36.0692;

        const response = await fetch(
            `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&units=metric&appid=${apiKey}&lang=ru`
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (!data || !data.main) {
            throw new Error('Некорректные данные от API');
        }

        const weatherInfo = `${Math.round(data.main.temp)}°C ${data.wind.speed.toFixed(1)} м/с ${getWindDirection(data.wind.deg)} ${Math.round(data.main.pressure * 0.750062)} мм рт. ст. ${data.main.humidity}%`;

        const weatherContainer = document.querySelector('.weather-data');
        const iconContainer = document.querySelector('.weather-icon');

        if (weatherContainer && iconContainer) {
            weatherContainer.textContent = weatherInfo;
            iconContainer.style.display = 'inline-block';
            iconContainer.style.backgroundImage = `url(https://openweathermap.org/img/w/${data.weather[0].icon}.png)`;
        }

    } catch (error) {
        console.error('Ошибка получения погоды:', error);
        const weatherContainer = document.querySelector('.weather-data');
        const iconContainer = document.querySelector('.weather-icon');

        if (weatherContainer) {
            weatherContainer.textContent = 'Погода временно недоступна';
        }
        if (iconContainer) {
            iconContainer.style.display = 'none';
        }
    }
}

// Константа для интервала обновления (10 минут в миллисекундах)
export const WEATHER_UPDATE_INTERVAL = 10 * 60 * 1000;
